import { VStack } from "@repo/components/src/ui/vstack";
import {
  CampaignAnalyticFragmentFragment,
  CampaignMediaFragmentFragment,
} from "@repo/graphql/documents/campaign/fragment.generated";
import React, { useMemo } from "react";
import Hero from "../shared/hero";
import Section from "../shared/section";
import { ReportCampaign } from "../shared/types";
import Clips, { ClipItem } from "./clips";
import KpiGrid from "./kpiGrid";
import ProductionHealth from "./productionHealth";
import Ranking from "./ranking";

type Props = {
  campaign: ReportCampaign;
  medias: readonly CampaignMediaFragmentFragment[];
  report: CampaignAnalyticFragmentFragment;
  heroActions?: React.ReactNode;
};

const UgcReport = React.memo(
  ({ campaign, medias, report, heroActions }: Props) => {
    const clips = useMemo<ClipItem[]>(() => {
      const items: ClipItem[] = [];
      report.workOrders.forEach((workOrder) => {
        workOrder.details.forEach((detail) => {
          if (!detail.contentFile && !detail.approvedAt) return;
          items.push({ id: detail.id, workOrder, detail });
        });
      });
      return items;
    }, [report]);

    return (
      <VStack space="md">
        <Hero campaign={campaign} medias={medias} actions={heroActions} />

        <Section
          title="Métricas de producción"
          description="Indicadores de la producción de clips."
        >
          <KpiGrid report={report} />
        </Section>

        <Section
          title="Plan de producción"
          description="Salud de la operación: cuántas ODTs llegaron a aprobación y cuántas se cayeron en el camino."
        >
          <ProductionHealth report={report} />
        </Section>

        <Section
          title="Videos aprobados"
          description="Archivos descargables. Reproduce el video desde el reporte y descarga el original."
        >
          <Clips items={clips} rightOfUseMonths={campaign.rightOfUseMonths} />
        </Section>

        <Section
          title="Ranking de creadores UGC"
          description="Evaluación individual: clips entregados, tiempo a video, revisiones y costo por clip."
        >
          <Ranking workOrders={report.workOrders} />
        </Section>
      </VStack>
    );
  },
);

UgcReport.displayName = "UgcReport";

export default UgcReport;
